'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionWrapper = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _AccordionSection = require('acq-components/lib/composite-components/AccordionSection/AccordionSection');

var _BulletListItem = require('acq-components/lib/base-components/BulletListItem/BulletListItem');

var _svgFetcher = require('acq-components/lib/utils/svgFetcher');

var _svgFetcher2 = _interopRequireDefault(_svgFetcher);

var _accordion = require('../../redux/selectors/accordion');

var accordionSelector = _interopRequireWildcard(_accordion);

var _componentHelpers = require('../../utils/component-helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAccordionChildren = function getAccordionChildren(desc, removeCheckmarks, styles, itemHeader) {
  if (!desc) return null;

  if (Array.isArray(desc.content) && desc.content.length) {
    return _react2.default.createElement(
      'div',
      null,
      desc.content.map(function (item) {
        return getAccordionChildren(item.desc, removeCheckmarks, styles, item.header);
      })
    );
  }

  var descArr = desc[0] && desc[0].desc || desc || [];

  if (Array.isArray(descArr) && descArr.length) {
    return _react2.default.createElement(
      _BulletListItem.BulletListItem,
      {
        image: !removeCheckmarks && (0, _svgFetcher2.default)('checkmark', 'us-commercial', {
          className: 'blue-icon'
        }),
        styles: styles.accordionContentItem
      },
      _react2.default.createElement(
        'div',
        null,
        itemHeader && _react2.default.createElement(_Sanitizer.Sanitizer, {
          className: 'content-header',
          safelySetInnerHTML: itemHeader,
          Component: 'h3'
        }),
        _react2.default.createElement(_componentHelpers.DescParser, { descArray: descArr, InnerTag: 'span' })
      )
    );
  }

  return null;
};

function isDesktop() {
  if (typeof window !== 'undefined') {
    var width = window.innerWidth;
    var breakpoint = 1100;
    return width > breakpoint;
  }
}

var AccordionWrapper = function AccordionWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      namespace = _ref.namespace,
      _ref$removeCheckmarks = _ref.removeCheckmarks,
      removeCheckmarks = _ref$removeCheckmarks === undefined ? false : _ref$removeCheckmarks,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator', 'namespace', 'removeCheckmarks']);

  if (!props.accordionData || !props.middleSectionContent.length) return null;
  styles.accordion.accordion = '' + styles.accordionSection.accordion;

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded()
    },
    _react2.default.createElement(_AccordionSection.AccordionSection, {
      sectionClassName: styles.accordionSection.section,
      textboxClassName: styles.accordionSection.textBox,
      headerContainerClassName: styles.accordionSection.headerContainer,
      contentContainerClassName: styles.accordionSection.contentContainer,
      sectionImageClassName: styles.accordionSection.image,
      image: props.headerImage,
      header: {
        title: props.headerTitle,
        Component: 'h2',
        styles: {
          componentHeader: styles.titleStyles.componentHeader
        }
      },
      textbox: {
        components: {
          text: props.textbox
        },
        styles: {
          text: styles.accordionSection.text
        }
      },
      accordion: {
        toggledItems: isDesktop() ? [0] : [],
        containerClassName: styles.accordionSection.accordion,
        panelMiddleSectionProps: props.middleSectionHeaders.map(function (header) {
          return {
            children: _react2.default.createElement(_Sanitizer.Sanitizer, { safelySetInnerHTML: header, Component: 'h3' }),
            className: styles.accordion.accordionPanel__titleContainer
          };
        }),
        bodyProps: props.middleSectionContent.map(function (content) {
          return {
            children: getAccordionChildren(content, removeCheckmarks, styles)
          };
        }),
        styles: styles.accordion
      },
      namespace: namespace,
      qeId: props.qeId
    })
  );
};

exports.AccordionWrapper = AccordionWrapper;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var selector = accordionSelector.getSelectors(ownProps.identifier, ownProps.isOnPage);
  return {
    accordionData: selector.getAccordionData(state),
    headerTitle: selector.getHeaderTitle(state),
    headerImage: selector.getHeaderImage(state),
    textbox: selector.getTextbox(state),
    middleSectionHeaders: selector.getMiddleSectionHeaders(state),
    middleSectionContent: selector.getMiddleSectionContent(state),
    qeId: selector.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccordionWrapper);